import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../store'
import { Skeleton } from '../common'
import { isAuthenticated as checkToken } from '../../services/api'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireAdmin?: boolean
}

/**
 * Route protetta che richiede autenticazione
 */
export default function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { utente, loading, checkAuth } = useAuthStore()
  const location = useLocation()
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    const verify = async () => {
      // Se c'è un token ma non abbiamo utente, verifica
      if (checkToken() && !utente) {
        await checkAuth()
      }
      setIsChecking(false)
    }
    verify()
  }, [checkAuth, utente])

  // Mostra loading mentre verifica auth
  if (loading || isChecking) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Skeleton className="h-96" />
      </div>
    )
  }

  // Non autenticato -> redirect a login
  if (!utente) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Richiede admin ma non è admin
  if (requireAdmin && utente.ruolo !== 'admin') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
